import { createSlice } from "@reduxjs/toolkit";
import { ROLES_LIST } from "../roles/roles.config";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    mail: null,
    token: null,
    roles: null,
    userData: null,
    selectedTenantId: null,
  },
  reducers: {
    setCredentials: (state, action) => {
      const { mail, accessToken, roles, userData } = action.payload;
      state.mail = mail;
      state.token = accessToken;
      state.roles = roles;
      state.userData = userData; // id, first & lastName, birthdate, phone

      const isSuperAdmin =
        Array.isArray(roles) && roles.includes(ROLES_LIST.SuperAdmin);

      if (!isSuperAdmin) {
        state.selectedTenantId = null;
      } else if (Object.prototype.hasOwnProperty.call(action.payload, "selectedTenantId")) {
        state.selectedTenantId = action.payload.selectedTenantId || null;
      }
    },
    setSelectedTenantId: (state, action) => {
      state.selectedTenantId = action.payload || null;
    },
    updateUserData: (state, action) => {
      state.userData = {
        ...(state.userData || {}),
        ...(action.payload || {}),
      };
    },
    logOut: (state) => {
      state.mail = null;
      state.token = null;
      state.roles = null;
      state.userData = null;
      state.selectedTenantId = null;
      localStorage.clear();
    },
  },
});

export const { setCredentials, setSelectedTenantId, updateUserData, logOut } =
  authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.mail;
export const selectCurrentToken = (state) => state.auth.token;
export const selectCurrentRoles = (state) => state.auth.roles;
export const selectCurrentUserData = (state) => state.auth.userData;
export const selectSelectedTenantId = (state) => state.auth.selectedTenantId;
